var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.modalVisible
        ? _c(
            "modal",
            {
              attrs: {
                "modal-type": _vm.modalType,
                title: _vm.title,
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "modal-title",
              },
              on: { close: _vm.onClose },
            },
            [_vm._t("content")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("opener", null, { openModal: _vm.openModal }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }